import { Layout } from 'components/layout';
import { Breadcrumbs } from 'components/bredcrambs';
import { aboutUs } from 'constants/routes-breadcrumbs';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';

import styles from './styles.module.css';
import { Card } from './card';
import { OtherPosts } from './other-posts';
import { TeamMember } from '../about-us/teamData';
import { Routes } from 'constants/routes';

export const CreatorPage = ({ member }: { member: TeamMember }) => {
  return (
    <div>
      <CustomMetadata metadata={allMetadata.aboutUs} />
      <Layout hasFooter isSearchInputMobileVisible bgVariant="basic">
        <div className={styles.container_s}>
          <main className={styles.main}>
            <Breadcrumbs
              items={[
                ...aboutUs,
                {
                  id: 2,
                  title: member.name,
                  path: Routes.aboutThisAuthor(member.name),
                },
              ]}
            />
            <div className={styles.info}>
              <Card member={member} />
              <OtherPosts />
            </div>
          </main>
        </div>
      </Layout>
    </div>
  );
};
